import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'icon-dashboard',
    link: '/pages/dashboard',
    home: true,
  },
  {
    title: 'Treatments',
    icon: 'icon-file',
    link: '/pages/treatments',
    children: [
      {
        title: 'Realtime',
        link: '/pages/treatments/realtime',
        pathMatch: ':id',
      },
      {
        title: 'Upload Treatment',
        link: '/pages/treatments/uploadTreatment',
        pathMatch: 'prefix',
      }
    ]
  },
  {
    title: 'Wells',
    icon: 'icon-wells',
    link: '/pages/wells',
    pathMatch: ':id',
  },
  {
    title: 'Pads',
    icon: 'icon-file',
    link: '/pages/pads',
    pathMatch: ':padName',
  },
  {
    title: 'Manage',
    icon: 'icon-manage',
    children: [
      {
        title: 'Companies',
        link: '/pages/manage/companies',
      },
      {
        title: 'Users',
        link: '/pages/manage/users',
      }
    ]
  },
  // {
  //   title: 'Inventory',
  //   icon: 'icon-inventory',
  //   link: '/pages/inventory',
  // },
  {
    title: 'Settings',
    icon: 'icon-mapping',
    link: '/pages/channelMapping',
  },
  // {
  //   title: 'Equip Monitoring',
  //   icon: 'icon-toolbox',
  //   link: '/pages/equipMonitoring',
  // }
];

export const MENU_MANAGE_CARBO_ADMIN: any[] = [
  {
    title: 'Companies',
    link: '/pages/manage/companies',
  },
  {
    title: 'Users',
    link: '/pages/manage/users',
  }
];
export const MENU_MANAGE_SERVICE_ADMIN: any[] = [
  {
    title: 'Users',
    link: '/pages/manage/users',
  },
  {
    title: 'Historical Wells',
    link: '/pages/manage/historicalWells',
  },
  {
    title: 'FracSpread',
    link: '/pages/manage/fracSpread',
  },
  {
    title: 'Equipments',
    link: '/pages/manage/equipments',
  },
];
export const MENU_MANAGE_OPERATOR_ADMIN: any[] = [
  {
    title: 'Users',
    link: '/pages/manage/users',
  },
  {
    title: 'Historical Wells',
    link: '/pages/manage/historicalWells',
  },
];
export const MENU_EQUIP_MONITORING: any = {
};


